import { render, staticRenderFns } from "./childrenPlan.vue?vue&type=template&id=110c6e84&scoped=true&"
import script from "./childrenPlan.vue?vue&type=script&lang=ts&"
export * from "./childrenPlan.vue?vue&type=script&lang=ts&"
import style0 from "./childrenPlan.vue?vue&type=style&index=0&id=110c6e84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c6e84",
  null
  
)

export default component.exports